module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue7_.png").default
        },
        {
            "time": 700,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue8_.png").default
        },
        {
            "time": 800,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue9_.png").default
        },
        {
            "time": 900,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue10_.png").default
        },
        {
            "time": 1000,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/p-death-blue11_.png").default
        },
        {
            "time": 1100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/empty_.png").default
        }
    ]
}
